import { Gamecloud } from '../../gamecloud';
import { GameserverUI, createGameserverUI } from './gameserverUI';
import { Notification } from '../../../notification/notfication';
import {initModal} from "../../../modal/modal";
import Axios from 'axios';

class Gameserver extends Gamecloud {
  /**
   * this variable will prevent that we send multiple requests to the server when one of them is not yet finished
   *
   * @type {boolean}
   * @private
   */
  private _blocked : boolean = false;

  /**
   * this variable is the maximum interval number that will be executed after each execution
   * see @GameserverCron to view the updateTimer interval
   *
   * @type {number}
   * @private
   */
  private _maxTimerPerExecution : number = 5;
  private interval;

  public constructor(private ui: GameserverUI, private total : number) {
    super();
    this.bindEvents();
    initModal();

    if (!this.isTeamspeak()) {
      window.addEventListener('socketData', (event: CustomEvent) => {
        if (event.detail.type == 'stateChanged' && event.detail.id === this.ui.getServiceId()) {
          this.ui.render(event.detail.data.state, this.ui.getLinks());
          this.bindEvents();
          initModal();
          this.ui.showInstalling(event.detail.data.details);
        }

        if (event.detail.id === this.ui.getServiceId()) {
          this.ui.showInstalling(event.detail.data.details);
        }
      });
    }

    // Determine delay between intervals for servers (to spread out the requests)
    const startDelay = GameserverCron.updateTimerBase * GameserverCron.timerList.length;

    let instance = this;

    window.setTimeout(
      function() {
          // Do an initial request after `pauseIncreaser` ms
          instance.fetchPlayers();
          // From there, set interval with a minimum of minUpdateTimer, based on the amount of servers
          instance.interval = window.setInterval(
              () =>
                  instance.fetchPlayers(),
              Math.max(GameserverCron.minUpdateTimer, GameserverCron.updateTimerBase * total)
          );
        },
        startDelay
    );

    GameserverCron.timerList.push(this.interval);
  }

  private isTeamspeak() {
    return this.ui.getLinks().settings.indexOf('teamspeak') > 0;
  }

  private destroyTimeout() {
    const idx = GameserverCron.timerList.indexOf(this.interval);
    if (idx !== -1) {
      GameserverCron.timerList.splice(idx, 1);
    }
    window.clearTimeout(this.interval);
  }

  /**
   * used for getting query informations from the gameservers
   */
  private fetchPlayers() {
    if(!this._blocked) {
      this._blocked = true;

      if (!this.isTeamspeak()) {
        const apiUrl: string = window.gamesServerApiQuery;
        if (typeof window.atlasNodes !== 'undefined') {
          for (let key in window.atlasNodes){
            if (window.atlasNodes.hasOwnProperty(key)) {
              let serverId = window.atlasNodes[key];
              Axios.get( apiUrl + window.atlasNodes[key], {
                responseType: 'json'
              }).then((response) => {
                this._blocked = false;
                this.ui.renderNodeMeta(response.data, serverId, this.destroyTimeout.bind(this));
              });
            }
          }
        }

        Axios.get( apiUrl + this.ui.getServerId(), {
          responseType: 'json'
        }).then((response) => {
            this._blocked = false;
            this.ui.renderMeta(response.data, this.destroyTimeout.bind(this));
        });
      } else {
        Axios.get(window.basePath + window.regionPrefix + '/server/teamspeak/' + this.ui.getServerId() + '/getLiveData', {
          responseType: 'json'
        }).then((response) => {
          this._blocked = false;
          const state = response.data.state;
          //Update UI for Online TS Server
          if (state === 'online') {
            this.ui.render(6, this.ui.getLinks());
            this.ui.renderMeta({
              currentPlayers: response.data.online,
              maxPlayers: response.data.slots,
              ipAddress: this.ui.getIP(),
              online: true,
              queried: "true",
              name: this.ui.getName(),
            }, this.destroyTimeout.bind(this));
          } else if (state === 'offline') {
            this.ui.render(3, this.ui.getLinks());
            //Update UI for Offline TS Server
            this.ui.renderMeta({
              currentPlayers: response.data.online,
              maxPlayers: response.data.slots,
              ipAddress: this.ui.getIP(),
              online: false,
              queried: "true",
              name: this.ui.getName(),
            }, this.destroyTimeout.bind(this));
          } else {
            this.ui.render(100, this.ui.getLinks());
          }

          // Bind events and reinit tooltips, modals
          this.bindEvents();
          // window.tooltips = initTooltip();
          initModal();
        });
      }
    }
  }

  private bindEvents() {
    this.ui.onRestart(this.enableLoading.bind(this), this.disableLoading.bind(this), this.onError.bind(this));
    this.ui.onStart(this.enableLoading.bind(this), this.disableLoading.bind(this), this.onError.bind(this));
    this.ui.onStop(this.enableLoading.bind(this), this.disableLoading.bind(this), this.onError.bind(this));
    this.ui.onDelete(this.enableLoading.bind(this), this.destroy.bind(this), this.cancelDelete.bind(this));
  }

  /**
   * Destroy server
   * Remove the server from the DOM
   */
  private destroy() {
    this.ui.destroyServer(this.disableLoading.bind(this));
  }

  /**
   * Cancel delete progress
   */
  private cancelDelete() {
    this.ui.reset();
  }

  /**
   * Show Loading animation
  */
  private enableLoading(): void {
    this.ui.loading(true);
  }

  /**
   * Hide loading animation
   */
  private disableLoading(): void {
    this.ui.loading(false);
  }

  /**
   * Something went wrong
   * Show a error message
   * @param error
   */
  private onError(error): void {
    new Notification('danger', 'Ooops', error.message)
  }
}

/**
 * this class is used for the setInterval of the query
 * endpoint, it can be edited to increase the @updateTimer
 * the @timerList will be used to track every timer
 */
class GameserverCron {
    static timerList : number[] = [];
    static updateTimerBase : number = 1000;
    static minUpdateTimer : number = 5000;
}

export function initGameserver() {
  const uiInstances: GameserverUI[] = createGameserverUI();

  return uiInstances.map((ui: GameserverUI) => {
    return new Gameserver(ui, uiInstances.length);
  });
}
